import { Icon } from "@chakra-ui/react";

export default function TikTok({ ...props }) {
  return (
    <Icon width="32" height="32" viewBox="0 0 32 32" {...props}>
      <g fill="currentColor">
        <path
          d="M16,0 C24.8362667,0 32,7.1632 32,16 C32,24.8362667 24.8362667,32 16,32 C7.16373333,32 0,24.8362667 0,16 C0,7.1632 7.16373333,0 16,0 Z M20.4828562,6 L20.4828562,6.00600019 L17.1767489,6.00600019 L17.1767489,17.9523878 C17.6747651,24.3305947 11.6865708,23.3645634 11.2245558,20.1004575 C10.984548,18.3964022 11.848576,17.4303709 13.3726255,16.9143541 C13.882642,16.7403485 14.4406601,16.6083442 14.9626771,16.5243415 L14.9626771,16.5243415 L14.9626771,13.1582322 C8.11045474,13.4042402 6.8024123,19.5424394 8.93848161,23.0405529 C12.2625895,28.4767292 20.5308577,26.1066524 20.5308577,18.5224063 L20.5308577,18.5224063 L20.5308577,12.5522126 C22.1569105,13.5362445 23.5549558,14.0582614 25.1510076,13.9022564 L25.1510076,13.9022564 L25.1510076,10.7101528 C22.3969183,10.530147 20.8128669,8.83809208 20.4828562,6 L20.4828562,6 Z"
          id="Shape"
        />
      </g>
    </Icon>
  );
}
